<template>
	<div
		class="textarea-wrapper"
		:class="[
			{ 'textarea--cart': cartStyling },
			{ 'textarea--lightTheme': lightTheme }
		]"
	>
		<label
			class="input__label"
			:class="[{ 'textarea__label--disabled': isDisabled }]"
		>
			<textarea
				v-if="stringId != ''"
				rows="4"
				cols="50"
				:class="['formtext', 'textarea', { 'textarea--error': hasError }]"
				:placeholder="placeholderValue"
				:data-id="stringId"
				v-bind:value="value"
				v-on:input="$emit('textarea', $event.target.value)"
				:disabled="isDisabled"
			>
			<textarea v-else
				rows="4"
				cols="50"
				:class="['formtext', 'textarea', { 'textarea--error': hasError }]"
				:placeholder="placeholderValue"
				:data-id="dataId"
				v-bind:value="value"
				v-on:input="$emit('textarea', $event.target.value)"
				:disabled="isDisabled"
			>
			</textarea
			>
			<span class="textarea__error" v-if="errorMessage != ''">
				{{ errorMessage }}
			</span>
		</label>
	</div>
</template>

<script>
export default {
	name: 'Textarea',
	props: {
		dataId: {
			type: Number,
			default: 0
		},
		stringId: {
			type: [String, Number],
			default: ''
		},
		placeholderValue: {
			type: String,
			default: ''
		},
		addclass: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		errorMessage: {
			type: String,
			default: ''
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		hasError: {
			type: Boolean,
			default: false
		},
		cartStyling: {
			type: Boolean,
			default: false
		},
		lightTheme: {
			type: Boolean,
			default: false
		}
	},
	methods: {}
}
</script>

<style scoped lang="scss">
.textarea-wrapper {
	display: flex;

	.textarea__label {
		display: flex;
		position: relative;
		&--disabled {
			opacity: 0.5;
			pointer-events: none;
		}
	}
	.textarea-title {
	}
	.textarea {
		//@extend .formtext;
		display: block;
		outline: 0;
		background: $colorInputBackground;
		border: 1px solid $colorInputBorder;
		border-radius: 5px;
		color: $colorInputText;
		padding: 8px 15px;
		width: 100%;
		box-sizing: border-box;

		// color: #2A3E61;
		font-size: 16px;
		line-height: 22px;

		&--error {
			color: $colorWhite;
			background: $colorRed;
		}
		&--error::placeholder {
			color: $colorWhite;
		}
	}
	.textarea__error {
		color: $colorRed;
		display: inline-block;
		font-size: 10px;
		line-height: 15px;
		margin-top: 10px;
	}

	&.textarea--cart {
		.textarea__title {
			color: $colorGrey8;
			font-size: 16px;
			line-height: 18px;
		}
	}

	&.textarea--lightTheme {
		.textarea {
			background-color: $colorWhite;
		}
	}
}
</style>
